import { ArrowBack } from "@mui/icons-material";
import { Button } from "@mui/material";

export default function BackButton() {
  return (
    <Button
      variant="contained"
      color="primary"
      size="small"
      sx={{
        backgroundColor: "#f9de4b",
        padding: "5px 10px",
        color: "black",
        borderRadius: "8px",
      }}
      onClick={() => window.history.back()}
    >
      <ArrowBack />
    </Button>
  );
}
